import { useParams } from 'react-router-dom';
/**
 * @typedef {{carleadHash: string}} PageParams
 */

/**
 *
 * @returns {string}
 */

export default function useCarleadHashParam() {
  /**@type {PageParams} */
  const {
    carleadHash
  } = useParams();
  return carleadHash;
}